import axios from "axios"

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin-token")
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default {
  login(credentials) {
    return apiClient.post("/auth/login", credentials)
  },

  getSubmissions(params = {}) {
    return apiClient.get("/submissions", { params })
  },

  postSubmission(payload) {
    return apiClient.post("/submissions", payload)
  },

  deleteSubmission(id) {
    return apiClient.delete(`/submissions/${id}`)
  },

  bulkDeleteSubmissions(ids) {
    return apiClient.post("/submissions/bulk-delete", { ids })
  },

  changePassword(payload) {
    return apiClient.put("auth/change-password", payload);
  },
}
